import type { DeepRequired } from '../fixtures.types'

const verificationCollection: DeepRequired<VerificationCollection> = {
  __typename: 'VerificationCollection',
  collection_id: 'TEST_ID',
  name: null,
  passed: null,
  outstanding_optional: null,
  required_for_future_transition: null,
  required_for_next_transition: null,
  verifications: [],
  version: '1',
}

export default verificationCollection
